
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Źródło danych',
	'dataSourceId': 'Id.',
	'dataSourceType': 'Typ',
	'dataSourceName': 'Nazwa',
	'dataSourcePath': 'Ścieżka',
	'showInfoForAll': 'Pokaż czas trwania dla wszystkich wizualizacji',
	'hideInfoForAll': 'Ukryj czas trwania dla wszystkich wizualizacji',
	'showPerformanceDetails': 'Uruchom ponownie wszystkie widgety w celu uwzględnienia szczegółów wydajności',
	'slotMappingField': 'Odwzorowania szczelin',
	'slotDataMapping': 'Odwzorowanie',
	'slotID': 'ID',
	'slotCaption': 'Podpis',
	'slotMandatory': 'Wymagane',
	'slotIsMandatory': 'Tak',
	'slotIsNotMandatory': 'Nie',
	'infoNotAvailable': 'Niedostępne',
	'performanceSection': 'Działanie',
	'durationField': 'Czas trwania',
	'singleQueryTime': 'Zapytanie do serwera (ms)',
	'multipleQueryTime': 'Zapytanie do serwera %{name} (ms)',
	'liveWidgetTotalTime': 'Łącznie (ms)',
	'renderTimeNotAvailable': 'Niedostępne',
	'renderInProgress': '(w toku)',
	'interactToTriggerQuery': 'Interakcja z widgetem w celu wyzwolenia zapytania',
	'fetchQuery': 'Pobierz zapytanie',
	'showSQLMDX': 'Pokaż SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informacje o zapytaniu',
	'queryInfoNotAvailable': 'Informacje o zapytaniu nie jest dostępna',
	'query': 'Zapytanie',
	'copy': 'Kopiuj',
	'close': 'Zamknij'
});
